import { computed, ref } from '@vue/composition-api';

import type { Task } from '@/types';
import { taskIsFinished } from '@/utils';

// Initiate Analysis Menu
const initiateAnalysisOpen = ref(false);

// Completed Analysis Menu
const completedAnalysesOpen = ref(false);
const tasks = ref<Task[]>([]);
const ongoingTasks = computed(() => tasks.value.filter((task) => !taskIsFinished(task)));

export {
  initiateAnalysisOpen,
  completedAnalysesOpen,
  tasks,
  ongoingTasks,
};
